"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDENTIFICATION_CITIZEN_QUESTION = exports.AFFORDABLE_PERSON = exports.PERSON = exports.ID_SECTION = void 0;
var entities_1 = require("@common/entities");
var SOCIAL_SECURITY_NUMBER_1 = require("./SOCIAL_SECURITY_NUMBER");
var constants_1 = require("../../constants");
var DRIVERS_LICENSE_1 = require("./DRIVERS_LICENSE");
exports.ID_SECTION = {
    required: false,
    documentUpload: {
        enabled: false,
        required: true,
        maxFilesAllowed: '2',
        verifyDocumentUpload: true,
    },
    idTypes: [],
};
exports.PERSON = {
    showCitizenQuestion: true,
    primaryId: __assign(__assign({}, exports.ID_SECTION), { required: true, idTypes: [
            __assign(__assign({}, SOCIAL_SECURITY_NUMBER_1.SOCIAL_SECURITY_NUMBER), { fields: SOCIAL_SECURITY_NUMBER_1.SOCIAL_SECURITY_NUMBER.fields.map(function (field) { return (__assign(__assign({}, field), { enabled: true, required: true })); }) }),
        ] }),
    additionalPrimaryId: exports.ID_SECTION,
    alternateIds: __assign(__assign({}, exports.ID_SECTION), { idsRequired: 0 }),
};
exports.AFFORDABLE_PERSON = {
    showCitizenQuestion: true,
    primaryId: __assign(__assign({}, exports.ID_SECTION), { idTypes: [DRIVERS_LICENSE_1.DRIVERS_LICENSE] }),
    additionalPrimaryId: exports.ID_SECTION,
    alternateIds: __assign(__assign({}, exports.ID_SECTION), { idsRequired: 0 }),
};
exports.IDENTIFICATION_CITIZEN_QUESTION = [
    {
        name: 'is_us_citizen',
        label: entities_1.CITIZENSHIP_QUESTION_PREFIX,
        options: constants_1.YES_NO_OPTIONS,
        defaultValue: '',
        type: entities_1.FieldType.Radio,
        customType: entities_1.FieldType.Radio,
        enabled: true,
        required: true,
    },
];
